import { render, staticRenderFns } from "./HorizontalInput.vue?vue&type=template&id=85fc2060&scoped=true&"
import script from "./HorizontalInput.vue?vue&type=script&lang=js&"
export * from "./HorizontalInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fc2060",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85fc2060')) {
      api.createRecord('85fc2060', component.options)
    } else {
      api.reload('85fc2060', component.options)
    }
    module.hot.accept("./HorizontalInput.vue?vue&type=template&id=85fc2060&scoped=true&", function () {
      api.rerender('85fc2060', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inputs/HorizontalInput.vue"
export default component.exports